import { Validate } from '../../components/edit/EditProps';

export const validateScore: Validate<number, string> = (value) => {
  if (value === undefined || value === null) return 'Score cannot be empty';
  const num = Number(value);
  if (Number.isNaN(num)) return 'Score must be a number';
  if (num < 0) return 'Score cannot be negative';
  return true;
};
